import { Alert, Chip, Divider, FormHelperText, Grid, IconButton } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { CustomSelectTextFieldNoForm, CustomTextAreaNoForm, CustomTextFieldNoForm } from '@/shared/components/ui';
import { gridSizeConst2, gridSizeMdLg10, gridSizeMdLg12, gridSizeMdLg6, urlBackend } from '@/shared';
import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { useGetActivityType, useGetIncidents, useGetNodo } from '../actions/noc-module.actions';
import { AddBox } from '@mui/icons-material';
import { erpApi } from '@/shared/axios';
import CustomAutocompleteFetchForm from '@/shared/components/ui/CustomAutocompleteFetchForm';
import { useForm } from "react-hook-form";
import useAutocompleteClienteSoftnetFetch from '../hooks/useAutocompleteClienteSoftnetFetch';
import { ClienteSoftnet } from '../interfaces/contratos.interface';
const { get, post } = erpApi();

export type ViewActividadesModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    form: any;
};

export type BoxType = {
    name: string;
};

const ViewActividadesModal: React.FC<ViewActividadesModalProps> = ({
    open,
    setOpen,
    form
}) => {
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;

    //* handlers
    const handleClose = () => {
        setOpen(false);
    };

    const [requiereCoordenadas, setRequiereCoordenadas] = useState(false);
    const [requiereCajas, setRequiereCajas] = useState(false);

    const [boxName, setBoxName] = useState('');

    const [listaNodos, setListaNodos] = useState<any[]>([]) as any;
    const useNodoMutation = useGetNodo();

    const [listaTipoActividad, setListaTipoActividad] = useState<any[]>([]);
    const useActivityTypeMutation = useGetActivityType();

    const [listaIncidencias, setListaIncidencias] = useState<any[]>([]);
    const useGetIncidentsMutation = useGetIncidents();

    useEffect(() => {
        const fetchData = async () => {
            const response = await useActivityTypeMutation.mutateAsync([]);
            setListaTipoActividad(response.data ?? []);

            const responseNodo = await useNodoMutation.mutateAsync([]);
            setListaNodos(responseNodo.data ?? []);

            const responseIncidencias = await useGetIncidentsMutation.mutateAsync([]);
            setListaIncidencias(responseIncidencias.data ?? []);
        };
        fetchData();
    }, []);

    const listaServicios = () => {
        return [
            { id_servicio: 'CORRECTIVO', nombre: 'CORRECTIVO' },
            { id_servicio: 'PREDICTIVO', nombre: 'PREDICTIVO' },
            { id_servicio: 'EMERGENTE', nombre: 'EMERGENTE' },
            { id_servicio: 'PREVENTIVO', nombre: 'PREVENTIVO' },
        ];
    }

    const listaTipoOrden = () => {
        return [
            { id_tipo_orden: 'RADIO ENLACE', nombre: 'RADIO ENLACE' },
            { id_tipo_orden: 'FIBRA OPTICA', nombre: 'FIBRA ÓPTICA' },
            { id_tipo_orden: 'ELECTRICO', nombre: 'ELÉCTRICO' },
        ];
    }

    const listaDirigido = () => {
        return [
            { id_dirigido: 'NODO', nombre: 'NODO' },
            { id_dirigido: 'CLIENTE', nombre: 'CLIENTE' },
        ];
    }

    const listaTipoCliente = () => {
        return [
            { id_tipo_cliente: 'PYME', nombre: 'PYME' },
            { id_tipo_cliente: 'CORPORATIVO', nombre: 'CORPORATIVO' },
            { id_tipo_cliente: 'ISP', nombre: 'ISP' },
        ];
    }

    const [activity, setActivity] = useState({
        activityName: '',
        forTheActivity: '',
        typeClient: '',
        type: '',
        nodeCode: '',
        nodeName: '',
        nodeStoreCode: '',
        nodeLocationCode: '',
        activityType: '',
        sector: '',
        idIncidence: '',
        initialCoordinate: '',
        finalCoordinate: '',
        isBoxInstallation: false,
        service: '',
        userRegister: username,
        activityStatus: 'PENDIENTE',
        activityDetail: '',
        primarySecondaryBox: [] as BoxType[],
        contractIdSoftnet: '',
        clientName: '',
        clientStoreCode: '',
        clientLocationCode: '',
    });

    const handleChange = (field: string, value: any) => {
        setActivity(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const deleteBoxByIndex = (index: number) => {
        setActivity(prev => ({
            ...prev,
            primarySecondaryBox: prev.primarySecondaryBox.filter((_, i) => i !== index)
        }));
    };

    const addActivity = () => {

        if (activity.type === '') {
            toast.error("Seleccione un tipo");
            return;
        }

        if (activity.activityName === '') {
            toast.error("Ingrese el nombre de la actividad");
            return;
        }

        if (activity.forTheActivity === '') {
            toast.error("Seleccione una opción de Dirigido A");
            return;
        }

        if (activity.forTheActivity === 'NODO') {
            if (activity.nodeCode === '') {
                toast.error("Seleccione un Nodo");
                return;
            }
            if (activity.nodeLocationCode === '') {
                toast.error("El Nodo Asignado no cuenta con la ubicacion de productos, debe primero crearla.");
                return false;
            }
        }
        if (activity.forTheActivity === 'CLIENTE') {
            if (activity.typeClient === '') {
                toast.error("Seleccione un tipo de cliente");
                return;
            }
            if (activity.contractIdSoftnet === '') {
                toast.error("Seleccione un cliente");
                return;
            }
            // falta validar bodega ubicacion
        }

        if (activity.activityType === '') {
            toast.error("Seleccione una Actividad");
            return;
        }
        if (activity.idIncidence === '') {
            toast.error("Seleccione una Incidencia");
            return;
        }
        if (activity.sector === '') {
            toast.error("Detalle el sector");
            return;
        }
        if (activity.service === '') {
            toast.error("Seleccione el Servicio");
            return;
        }
        if (activity.activityDetail === '') {
            toast.error("Detalle una observación");
            return;
        }

        // if (requiereCoordenadas && coordenadaInicialError) {
        //     toast.error("Ingrese una coordenada inicial válida");
        //     return;
        // }

        // if (requiereCoordenadas && coordenadaFinalError) {
        //     toast.error("Ingrese una coordenada final válida");
        //     return;
        // }

        if (requiereCajas && activity.primarySecondaryBox.length <= 0) {
            toast.error("Debe ingresar al menos una Caja");
            return;
        }

        const currentActivities = form.getValues("activitiesOrder") || [];

        form.setValue("activitiesOrder", [
            ...currentActivities,
            activity
        ]);

        toast.success("Actividad agregada correctamente, por favor guardar los cambios");
        setRequiereCajas(false);
        setRequiereCoordenadas(false);
        // setCoordenadaInicialError(false);
        // setCoordenadaFinalError(false);
        setActivity({
            activityName: '',
            forTheActivity: '',
            typeClient: '',
            type: '',
            nodeCode: '',
            nodeName: '',
            nodeStoreCode: '',
            nodeLocationCode: '',
            activityType: '',
            sector: '',
            idIncidence: '',
            initialCoordinate: '',
            finalCoordinate: '',
            isBoxInstallation: false,
            service: '',
            userRegister: username,
            activityStatus: 'PENDIENTE',
            activityDetail: '',
            primarySecondaryBox: [],
            contractIdSoftnet: '',
            clientName: '',
            clientStoreCode: '',
            clientLocationCode: '',
        })
    };

    const [loadingUbicacion, setLoadingUbicacion] = useState(false);
    const [nodeWithoutLocation, setNodeWithoutLocation] = useState(false);

    // const [coordenadaInicialError, setCoordenadaInicialError] = useState(false);
    // const [coordenadaFinalError, setCoordenadaFinalError] = useState(false);
    const isValidCoordinate = (value: string): boolean => {
        const parts = value.split(',').map((part) => part.trim());

        if (parts.length !== 2) {
            return false;
        }

        const latitude = Number(parts[0]);
        const longitude = Number(parts[1]);

        if (isNaN(latitude) || isNaN(longitude)) {
            return false;
        }

        return (
            latitude >= -90 &&
            latitude <= 90 &&
            longitude >= -180 &&
            longitude <= 180
        );
    };

    const [selectDirigido, setSelectDirigido] = useState('');

    const forms = useForm<any>({
        defaultValues: {
            contract_id_softnet: null,
        }
    });

    const {
        control,
        reset
    } = forms;

    const { fetchAutocompleteClienteSoftnet } = useAutocompleteClienteSoftnetFetch();

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Agregar Actividad"}
                width="100%"
                contentNode={
                    <>
                        <Grid container spacing={3}>

                            {nodeWithoutLocation && (
                                <Grid item {...gridSizeMdLg12}>
                                    <Alert
                                        severity="warning"
                                        variant="outlined"
                                        color='warning'
                                    >
                                        El nodo seleccionado no cuenta con la Ubicación de Destino (Inventario)
                                    </Alert>
                                </Grid>
                            )}

                            <CustomSelectTextFieldNoForm<any>
                                key={`type-${activity.type}`}
                                label="Tipo"
                                defaultValue={activity.type}
                                // options
                                options={listaTipoOrden() || []}
                                menuItemKey="id_tipo_orden"
                                valueKey="id_tipo_orden"
                                labelKey="nombre"
                                size={gridSizeMdLg6}
                                onChangeValue={(value) => handleChange('type', value)}
                            />

                            <CustomTextFieldNoForm
                                label="Nombre de la Actividad"
                                defaultValue={activity.activityName}
                                size={gridSizeMdLg6}
                                onChangeCustom={(e) => handleChange('activityName', e.target.value)}
                            />

                            <CustomSelectTextFieldNoForm<any>
                                key={`forTheActivity-${activity.forTheActivity}`}
                                label="Dirigido A"
                                defaultValue={activity.forTheActivity}
                                // options
                                options={listaDirigido() || []}
                                menuItemKey="id_dirigido"
                                valueKey="id_dirigido"
                                labelKey="nombre"
                                size={gridSizeMdLg6}
                                onChangeValue={(value) => {
                                    setSelectDirigido(value);
                                    handleChange('forTheActivity', value);
                                }}
                            />

                            {selectDirigido == "CLIENTE" && (
                                <>
                                    <CustomSelectTextFieldNoForm<any>
                                        key={`type-client-${activity.typeClient}`}
                                        label="Tipo de Cliente"
                                        defaultValue={activity.typeClient}
                                        // options
                                        options={listaTipoCliente() || []}
                                        menuItemKey="id_tipo_cliente"
                                        valueKey="id_tipo_cliente"
                                        labelKey="nombre"
                                        size={gridSizeMdLg6}
                                        onChangeValue={(value) => handleChange('typeClient', value)}
                                    />

                                    <CustomAutocompleteFetchForm<ClienteSoftnet>
                                        required={false}
                                        control={control}
                                        size={gridSizeMdLg12}
                                        name="clientName"
                                        label="Cliente"
                                        fetchData={fetchAutocompleteClienteSoftnet}
                                        getOptionLabel={(opt) => opt.nombre_cliente || ''}
                                        key={'autocomplete-nombre_cliente'}
                                        getOptionKey={(o) => o.nombre_cliente!}
                                        keySearch="nombre_cliente"
                                        initialInputValue={activity?.clientName || ''}
                                        loadOptionByValue={async (value) => {
                                            const { options } = await fetchAutocompleteClienteSoftnet(
                                                value as string,
                                                1,
                                                false,
                                                'nombre_cliente',
                                                {}
                                            );
                                            return options[0] ?? null;
                                        }}
                                        onChangeRawValue={async (row) => {
                                            handleChange('contractIdSoftnet', row?.id_contrato);
                                            handleChange('clientName', row?.nombre_cliente);
                                            handleChange('nodeCode', '')
                                            handleChange('nodeName', '')
                                            // buscar ubicacion cliente
                                            if ((row?.id_contrato ?? 0) > 0) {
                                                try {
                                                    let nombreUbicacionCliente = "Cliente " + row?.numero_documento;
                                                    let numeroReferenciaUbicacion = "CONT-" + row?.id_contrato;
                                                    setLoadingUbicacion(true)
                                                    const resp = await get<any[]>(
                                                        `${urlBackend}api/v1/ubicacion/?page_size=1&estado=true&nombre=${nombreUbicacionCliente}&numero_referencia=${numeroReferenciaUbicacion}`,
                                                        true
                                                    ) as any;
                                                    if (resp?.data?.data?.length > 0) {
                                                        const data = resp.data.data[0]
                                                        handleChange(
                                                            'clientStoreCode',
                                                            data?.bodega_data?.codigo || ''
                                                        )
                                                        handleChange(
                                                            'clientLocationCode',
                                                            data?.codigo || ''
                                                        )
                                                        setNodeWithoutLocation(false)
                                                    } else {
                                                        // crearla si no existe
                                                        let requestCreateUbicacion = {
                                                            'estado': true,
                                                            'nombre': nombreUbicacionCliente,
                                                            'bodega': '6c34988a-7bcf-4ad7-84fd-0ffc7fc4662e',
                                                            'numero_referencia': numeroReferenciaUbicacion
                                                        }

                                                        const resp = await post<any[]>(
                                                            `${urlBackend}api/v1/ubicacion/`,
                                                            requestCreateUbicacion,
                                                            true
                                                        ) as any;

                                                        if (resp?.code === 200 && resp?.status === 'success' && resp?.data) {
                                                            const data = resp.data
                                                            handleChange(
                                                                'clientStoreCode',
                                                                data?.bodega_data?.codigo || ''
                                                            )
                                                            handleChange(
                                                                'clientLocationCode',
                                                                data?.codigo || ''
                                                            )
                                                            setNodeWithoutLocation(false)
                                                        } else {
                                                            setNodeWithoutLocation(true)
                                                        }
                                                    }
                                                } catch (error) {
                                                    setNodeWithoutLocation(true)
                                                } finally {
                                                    setLoadingUbicacion(false)
                                                }
                                            }
                                        }}
                                    />
                                </>
                            )}

                            {selectDirigido == "NODO" && (
                                <CustomSelectTextFieldNoForm<any>
                                    key={`nodeCode-${activity.nodeCode}`}
                                    label="Nodo"
                                    defaultValue={activity.nodeCode || ''}
                                    // options
                                    options={listaNodos?.data || []}
                                    menuItemKey="nodeCode"
                                    valueKey="codigo"
                                    labelKey="nombre"
                                    size={gridSizeMdLg12}
                                    disabled={loadingUbicacion}
                                    // onChangeValue={(value) => handleChange('nodeCode', value)}
                                    onChangeRawValue={async (row) => {
                                        handleChange('nodeCode', row.codigo)
                                        handleChange('nodeName', row.nombre)
                                        handleChange('nodeStoreCode', '')
                                        handleChange('nodeLocationCode', '')
                                        setNodeWithoutLocation(false)

                                        if (!row.ubicacion) {
                                            setNodeWithoutLocation(true)
                                            return
                                        }
                                        try {
                                            setLoadingUbicacion(true)
                                            const resp = await get<any[]>(
                                                `${urlBackend}api/v1/ubicacion/?page_size=1&estado=true&codigo=${row.ubicacion}`,
                                                true
                                            ) as any;
                                            if (resp?.data?.data?.length > 0) {
                                                const data = resp.data.data[0]
                                                handleChange(
                                                    'nodeStoreCode',
                                                    data?.bodega_data?.codigo || ''
                                                )
                                                handleChange(
                                                    'nodeLocationCode',
                                                    data?.codigo || ''
                                                )
                                                setNodeWithoutLocation(false)
                                            } else {
                                                setNodeWithoutLocation(true)
                                            }
                                        } catch (error) {
                                            setNodeWithoutLocation(true)
                                        } finally {
                                            setLoadingUbicacion(false)
                                        }
                                    }}
                                />
                            )}

                            <CustomSelectTextFieldNoForm<any>
                                key={`activityType-${activity.activityType}`}
                                label="Actividad"
                                defaultValue={activity.activityType}
                                // options
                                options={listaTipoActividad.filter((val) => val.statusActivityType) || []}
                                menuItemKey="activityType"
                                valueKey="idActivityType"
                                labelKey="nameActivityType"
                                size={gridSizeMdLg6}
                                // onChangeValue={}
                                onChangeRawValue={(row) => {
                                    handleChange('activityType', row.idActivityType)
                                    handleChange('nameActivityType', row.nameActivityType)
                                }}
                            />

                            <CustomSelectTextFieldNoForm<any>
                                key={`idIncidence-${activity.idIncidence}`}
                                label="Incidencia"
                                defaultValue={activity.idIncidence}
                                // options
                                options={listaIncidencias.filter((val) => val.activityType.idActivityType === activity.activityType) || []}
                                menuItemKey="idIncidence"
                                valueKey="idIncidence"
                                labelKey="name"
                                size={gridSizeMdLg6}
                                onChangeRawValue={(row) => {
                                    handleChange('idIncidence', row.idIncidence)
                                    handleChange('nameIncidence', row.name)
                                    setRequiereCoordenadas(row.requireCoordinates)
                                    setRequiereCajas(row.isBoxInstallation)
                                    handleChange('isBoxInstallation', row.isBoxInstallation)
                                }}
                            />

                            <CustomTextFieldNoForm
                                label="Sector"
                                defaultValue={activity.sector}
                                size={gridSizeMdLg6}
                                onChangeCustom={(e) => handleChange('sector', e.target.value)}
                            />

                            <CustomTextFieldNoForm
                                label="Coordenada Inicial (-0.318945, -78.460111)"
                                defaultValue={activity.initialCoordinate}
                                size={gridSizeMdLg6}
                                disabled={!requiereCoordenadas}
                                onChangeCustom={(e) => {
                                    const value = e.target.value;
                                    handleChange('initialCoordinate', value);
                                    if (value && !isValidCoordinate(value)) {
                                        // aquí puedes manejar el error
                                        // setCoordenadaInicialError(true);
                                        // return;
                                    }
                                    // setCoordenadaInicialError(false);
                                }}
                                required={false}
                            />

                            <CustomTextFieldNoForm
                                label="Coordenada Final (-0.318945, -78.460111)"
                                defaultValue={activity.finalCoordinate}
                                size={gridSizeMdLg6}
                                disabled={!requiereCoordenadas}
                                onChangeCustom={(e) => {
                                    const value = e.target.value;
                                    handleChange('finalCoordinate', value);
                                    if (value && !isValidCoordinate(value)) {
                                        // aquí puedes manejar el error
                                        // setCoordenadaFinalError(true);
                                        // return;
                                    }
                                    // setCoordenadaFinalError(false);
                                }}
                                required={false}
                            />

                            <CustomSelectTextFieldNoForm<any>
                                key={`service-${activity.service}`}
                                label="Servicio"
                                defaultValue={activity.service}
                                // options
                                options={listaServicios() || []}
                                menuItemKey="id_servicio"
                                valueKey="id_servicio"
                                labelKey="nombre"
                                size={gridSizeMdLg6}
                                onChangeValue={(value) => handleChange('service', value)}
                            />

                            <Grid item container {...gridSizeMdLg6} spacing={1} alignItems={'center'}>
                                <CustomTextFieldNoForm
                                    label="Nombre de la Caja"
                                    defaultValue={boxName || ''}
                                    size={gridSizeMdLg10}
                                    onChangeCustom={(e) => setBoxName(e.target.value)}
                                    disabled={!requiereCajas}
                                />
                                <Grid item {...gridSizeConst2}>
                                    <IconButton
                                        disabled={!requiereCajas}
                                        onClick={(e) => {
                                            e.preventDefault();

                                            if (!boxName.trim()) {
                                                toast.error('Ingrese un nombre de caja')
                                                return;
                                            };

                                            const value = boxName.trim();
                                            const boxRegex = /^[A-Z]{3}\s\d+$/;

                                            if (!boxRegex.test(value)) {
                                                toast.error('El formato debe ser: AAA 12345');
                                                return;
                                            }

                                            setActivity(prev => ({
                                                ...prev,
                                                primarySecondaryBox: [
                                                    ...prev.primarySecondaryBox,
                                                    { name: boxName }
                                                ]
                                            }));

                                            setBoxName('');
                                        }}
                                        size="small">
                                        <AddBox />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Divider sx={{ my: 4 }} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} style={{ display: requiereCajas ? 'block' : 'none' }}>
                            <Grid item xs={12}>
                                <FormHelperText>CAJAS AGREGADAS</FormHelperText>
                                {activity.primarySecondaryBox.length > 0 ? activity.primarySecondaryBox.map((item, index) => {
                                    return (
                                        <Chip
                                            {...gridSizeConst2}
                                            color="success"
                                            label={item.name}
                                            variant="outlined"
                                            onDelete={() => deleteBoxByIndex(index)}
                                        />
                                    )
                                }) : 'Ninguna'}
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} style={{ display: requiereCajas ? 'block' : 'none' }}>
                            <Grid item xs={12}>
                                <Divider sx={{ my: 4 }} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <CustomTextAreaNoForm
                                label="Detalle una observación de la actividad"
                                size={gridSizeMdLg12}
                                value={activity.activityDetail}
                                onChangeValue={(value) => handleChange('activityDetail', value)}
                            />
                        </Grid>
                    </>
                }
                onClose={handleClose}
                onConfirm={addActivity}
            />
        </>
    );
};

export default ViewActividadesModal;
